export enum RecruiterStatus{
    approved = "Approved",
    pending = "Pending",
    rejected = "Rejected",
    blacklisted = "BlackListed",
    suspended = "Suspended",
    incomplete = "MarkIncomplete"
};